// 時間顯示。後端一律存 UTC、回 ISO 字串,畫面上一律顯示台北時間。
//
// 這兩件事必須一起做,不能只做一半:報價日期已經在後端換算成台北時區了,
// 若寄件紀錄還把 "2026-09-10T02:07:15.851042Z" 原樣印出來,同一個畫面上
// 就會有兩套時間觀,而且那串字根本不是給人看的。

/** 業主與客戶都在台灣,顯示時區只有這一個。 */
const TAIPEI = "Asia/Taipei";

/** ISO 字串是否已經帶了時區(Z 或 ±hh:mm)。 */
function hasTimezone(text: string): boolean {
  return /(?:Z|[+-]\d{2}:?\d{2})$/.test(text);
}

/**
 * 把後端回的 ISO 時間字串轉成台北時間的 `YYYY/MM/DD HH:mm`。
 *
 * - 空值回空字串,呼叫端可以直接放進 JSX。
 * - 看不懂的字串原樣回傳 —— 寧可讓人看到怪字串,也不要整頁炸掉。
 * - 沒帶時區標記時一律當成 UTC:資料庫存的就是 UTC,若讓 JS 當成本地時間解析,
 *   同一筆紀錄在不同時區的機器上會顯示成不同時間。
 */
export function formatTaipeiDateTime(iso: string | null | undefined): string {
  const text = String(iso ?? "").trim();
  if (text === "") return "";

  const date = new Date(hasTimezone(text) ? text : `${text}Z`);
  if (Number.isNaN(date.getTime())) return String(iso);

  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: TAIPEI,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    // h23:午夜要是 00 不是 24,不同 ICU 版本才給得出同一個答案。
    hourCycle: "h23",
  }).formatToParts(date);

  const pick = (type: Intl.DateTimeFormatPartTypes) => parts.find((part) => part.type === type)?.value ?? "";
  return `${pick("year")}/${pick("month")}/${pick("day")} ${pick("hour")}:${pick("minute")}`;
}
